/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import GetAppModal from "../../Common/modal/GetAppModal";
import { Link, useNavigate } from "react-router-dom";
import { usePostQuery } from "../../hooks/reactQueryHelper.js";
import { GetEventDetail, GetUpcomingEvents } from "../../services/Web.type.js";
import SkeletonCard from "../../Common/loader/Loader.js";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Marquee from "../../Common/Marquee/Marquee.js";
import RewardModal from "../../Common/modal/RewardModal.js";
import { RWebShare } from "react-web-share";
import { date } from "yup";


const EventDetails = () => {
  const cycling = "/media/assets/svg/directions-bike.svg";
  const walking = "/media/assets/svg/directions-walk.svg";
  const running = "/media/assets/svg/directions-run.svg";

  const [modalShow, setModalShow] = useState(false);
  const slug = window.location.pathname;
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [rewardShow, setRewardShow] = useState(false);
  const [time,setTime]=useState(new Date())
  const navigate = useNavigate();

  const fullUrl = `${GetEventDetail}${slug}`;

  const getEventDetailQuery = usePostQuery("getEventDetailQuery", fullUrl);

  useEffect(() => {
    getEventDetailQuery.mutate();
  }, []);
  
  useEffect(()=>{
    setInterval(() => {
      setTime(new Date(),1000)
    }, []);
  }
  )

  const closingDate = moment(
    getEventDetailQuery?.data?.result?.registrationClosingDate
  );

  const duration = moment.duration(closingDate.diff(moment()));

  const months = duration.months();
  const days = duration.days();
   const currTime = new Date().toLocaleTimeString();
  const resultString = [
    
    months > 0 ? `${months} Month${months > 1 ? "s" : ""}` : null,
    days > 0 ? `${days} Day${days > 1 ? "s" : ""}` : null,
]
    .filter(Boolean)
    .join(" ");
console.log(resultString)
  const getUpcomingEventQuery = usePostQuery(
    "getUpcomingEventQuery",
    GetUpcomingEvents,
    {}
  );

  useEffect(() => {
    getUpcomingEventQuery.mutate({
      search: "",
      eventTypeID: [],
      isGetAll: true,
    });
  }, []);

  const rewardText = getEventDetailQuery?.data?.result?.rewards;

  const truncatedRewardText =
    rewardText && rewardText.length > 50
      ? `${rewardText.slice(0, 50)}...`
      : rewardText;

  const [showTooltip, setShowTooltip] = useState(false);
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  useEffect(() => {
    if (
      getEventDetailQuery?.error?.response?.status === 400 &&
      getEventDetailQuery?.error?.response?.status === 404 &&
      getEventDetailQuery?.error?.response?.status === 500
    ) {
      navigate("/events");
    }
  }, [getEventDetailQuery?.error?.response?.status, navigate]);

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  const toggleEventRules = () => {
    setShowAll(!showAll);
  };

  const [showAll, setShowAll] = useState(false);

  const rulesToShow = showAll
    ? getEventDetailQuery?.data?.result?.eventRules
    : getEventDetailQuery?.data?.result?.eventRules?.slice(0, 3);

  return (
    <>
      <RewardModal
        rewardText={rewardText}
        show={rewardShow}
        onHide={() => setRewardShow(false)}
      />
      <GetAppModal show={modalShow} onHide={() => setModalShow(false)} />
      <main>
        <section className="mb-5 section-header-padding">
          <Container>
            <div className="bebas-neue-font section-title text-default-color text-uppercase p-4  text-center">
              <h1>Event Details</h1>
            </div>
            <Row className="justify-content-evenly">
              {getEventDetailQuery.isLoading ? (
                <SkeletonCard getEventDetailQuery={getEventDetailQuery} />
              ) : (
                <>
                  <Col lg={6} className="col-12">
                    <div className="image-container tab-view">
                      <div className="overlay rounded-4"></div>
                      <div
                        className="d-flex tab-view-share-btn transparent-bg align-items-center position-absolute top-0 top-right mx-4 my-4 border border-white rounded-pill px-2 py-2 gap-1 mobile-cycle-only"
                        style={{ fontWeight: "600",fontSize:'smaller' }}
                      >
                        <img
                          src={
                            getEventDetailQuery?.data?.result?.eventTypeID === 1
                              ? cycling
                              : getEventDetailQuery?.data?.result
                                  ?.eventTypeID === 2
                              ? walking
                              : getEventDetailQuery?.data?.result
                                  ?.eventTypeID === 3
                              ? running
                              : ""
                          }
                          height={20}
                        />
                        <p className="text plus-jakarta-sans-font  text-uppercase text-dark my-0" >
                          {getEventDetailQuery?.data?.result?.eventTypeName
                            ? getEventDetailQuery?.data?.result?.eventTypeName
                            : "N/A"}
                        </p>
                      </div>
                      <div
                        className="d-lg-none share-btn-padding tab-view-padding transparent-bg align-items-center position-absolute top-0 end-0 mx-4 my-4 border border-white rounded-circle mobile-share-only"
                        style={{ fontWeight: "600" }}
                      >
                        <RWebShare
                          data={{
                            text: getEventDetailQuery?.data?.result?.name,
                            url: `http://fitevent.engrossinfotech.com${slug}`,
                            title: getEventDetailQuery?.data?.result?.name,
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-share-fill"
                            viewBox="0 0 16 16"
                            id="shareButton"
                          >
                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5" />
                          </svg>
                        </RWebShare>
                      </div>

                      <Row>
                        <div className="col-auto position-absolute bottom-0 start-0 ms-2 mb-3">
                          <h2 className="text-white text-start bebas-neue-font mb-0 mobile-truncate">
                            {getEventDetailQuery?.data?.result?.name
                              ? getEventDetailQuery?.data?.result?.name
                              : "N/A"}
                          </h2>
                          <p className="text-white text-start fs-6 plus-jakarta-sans-font mb-0">
                            <span className="text-default-color">
                              {
                                getEventDetailQuery?.data?.result
                                  ?.totalParticipants
                              }{" "}
                              people
                            </span>{" "}
                            has already joined
                          </p>
                        </div>
                      </Row>

                      <img
                        src={
                          getEventDetailQuery?.data?.result?.webBannerImage
                            ? getEventDetailQuery?.data?.result?.webBannerImage
                            : "https://placehold.co/636x423?text=N/A"
                        }
                        className="img-fluid rounded-4 event-image-width"
                        alt=""
                      />
                    </div>
                  </Col>
                  <Col lg={6} className="col-12 tab-view-height">
                    <div
                      className="bg-F6F6F6 rounded-4 p-4 mobile-screen-reward event-details-height"
                      style={{ height: "425px" }}
                    >
                      <Row className="justify-content-between align-items-center mb-2">
                        <div className="col-auto">
                          <h2 className="bebas-neue-font text-start fw-bold mb-0 mobile-truncate">
                            {getEventDetailQuery?.data?.result?.name
                              ? getEventDetailQuery?.data?.result?.name
                              : "N/A"}
                          </h2>
                        </div>
                        <div className="col-auto">
                          <Button
                            type="button"
                            className="rounded-pill border-0 bg-default fw-bold py-2"
                            onClick={() => setModalShow(true)}
                          >
                            Join now
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-plus-lg fs-5"
                              viewBox="0 0 16 16"
                            >
                              <text
                                x="50%"
                                y="50%"
                                fontSize="10"
                                fontWeight="bold"
                                textAnchor="middle"
                                dominantBaseline="middle"
                                fill="currentColor"
                              >
                                +
                              </text>
                              <path
                                fillRule="evenodd"
                                d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                              />
                            </svg>
                          </Button>
                        </div>
                      </Row>

                      <Row className="mb-2">
                        <Col className="col-6 text-start">
                          <div className="d-flex gap-2 plus-jakarta-sans-font">
                            <img src="/media/assets/svg/arrows_outward.svg" />
                            <div className="card-text">Total Distance</div>
                          </div>
                          <div className="bebas-neue-font card-text fs-5">
                            {getEventDetailQuery?.data?.result?.totalDistance
                              ? getEventDetailQuery?.data?.result?.totalDistance
                              : "N/A"}{" "}
                            KM
                          </div>
                        </Col>
                        <Col className="col-6 text-start">
                          <div className="d-flex gap-2 plus-jakarta-sans-font">
                            <img src="/media/assets/svg/timer.svg" />
                            <div className="card-text">Event Duration</div>
                          </div>
                          <div className="bebas-neue-font card-text fs-5">
                            {getEventDetailQuery?.data?.result?.duration
                              ? getEventDetailQuery?.data?.result?.duration
                              : "N/A"}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mb-2">
                        <Col className="col-6 text-start">
                          <div className="d-flex gap-2 plus-jakarta-sans-font align-items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-clock-fill text-secondary"
                              viewBox="0 0 16 16"
                              style={{ color: "#767676" }}
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                            </svg>
                            <div className="card-text">Start Date</div>
                          </div>
                          <div className="bebas-neue-font card-text fs-5">
                            {moment(
                              getEventDetailQuery?.data?.result?.startDate
                            ).format("DD/MM/yyyy")
                              ? moment(
                                  getEventDetailQuery?.data?.result?.startDate
                                ).format("DD/MM/yyyy")
                              : "N/A"}
                          </div>
                        </Col>
                        <Col className="col-6 text-start">
                          <div className="d-flex gap-2 plus-jakarta-sans-font align-items-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-clock-fill"
                              viewBox="0 0 16 16"
                              style={{ color: "#767676" }}
                            >
                              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
                            </svg>
                            <div className="card-text">End Date</div>
                          </div>
                          <div className="bebas-neue-font card-text fs-5">
                            {moment(
                              getEventDetailQuery?.data?.result?.endDate
                            ).format("DD/MM/yyyy")
                              ? moment(
                                  getEventDetailQuery?.data?.result?.endDate
                                ).format("DD/MM/yyyy")
                              : "N/A"}
                          </div>
                        </Col>
                      </Row>

                      <Col className="col-8 text-start mt-0">
                        <div className="d-flex gap-2 plus-jakarta-sans-font">
                          <img src="/media/assets/svg/currency-rupee.svg" />
                          <div className="card-text">Joining Fees</div>
                        </div>
                        <div className="bebas-neue-font card-text fs-5">
                          {getEventDetailQuery?.data?.result?.joiningFees
                            ? getEventDetailQuery?.data?.result?.joiningFees
                            : "N/A"}
                        </div>
                      </Col>
                      <Col className="col-8 text-start mt-2 mb-1">
                        <div className="d-flex gap-1 align-items-center">
                          
                          {resultString ?
                          
                          (
                            
                            <>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="13"
                                height="13"
                                fill="#dc3545"
                                className="bi bi-exclamation-circle"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                              </svg>
                              <p className="card-text text-danger plus-jakarta-sans-font">
                              {days===1?`Event end in ${time.toLocaleTimeString()}` :
                                `Ends in ${resultString}`
                          }
                              </p>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </Col>
                      <Col className="text-start mt-2 d-none d-lg-block">
                        <div className="bg-white rounded-4 p-3 plus-jakarta-sans-font">
                          <div className="card-text fs-5">Rewards</div>
                          <div className="card-text fs-6">
                            You will get an Exclusive e-certificate from
                            Fitevent.
                          </div>
                          <div className="d-flex gap-2">
                            <img src="/media/assets/svg/info.svg" />
                            <OverlayTrigger
                              placement="bottom"
                              overlay={
                                <Tooltip width={100}>
                                  {getEventDetailQuery?.data?.result?.rewards
                                    ? getEventDetailQuery?.data?.result?.rewards
                                    : "No rewards"}
                                </Tooltip>
                              }
                              show={showTooltip}
                            >
                              <div
                                className="card-text fs-6"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                                onClick={() => setRewardShow(true)}
                              >
                                {truncatedRewardText
                                  ? truncatedRewardText
                                  : "No rewards"}
                              </div>
                            </OverlayTrigger>
                          </div>
                        </div>
                      </Col>
                    </div>
                  </Col>
                  <Col lg={6} className=" tab-view-margin ">
                    <div className="bg-F6F6F6 rounded-4 p-3 plus-jakarta-sans-font d-block d-lg-none">
                      <div className="card-text fs-5">Rewards</div>
                      <div className="card-text fs-6">
                        You will get an Exclusive e-certificate from Fitevent.
                      </div>
                      <div className="d-flex gap-2">
                        <img src="/media/assets/svg/info.svg" />
                        <div className="card-text fs-6">
                          The name on the certificate will be: Jessy Pink
                        </div>
                      </div>
                    </div>
                  </Col>
                </>
              )}
            </Row>
          </Container>
        </section>
        <section className="mb-5">
          <Container className="">
            <Row className="justify-content-evenly">
              <Col lg={6} className="col-12 p-4">
                <div className="plus-jakarta-sans-font text-start">
                  {getEventDetailQuery?.data?.result?.description && (
                    <h2 className="mb-3">About This Event</h2>
                  )}
                  {getEventDetailQuery.isLoading ? (
                    <ul>
                      {Array(4)
                        .fill()
                        .map((item, index) => (
                          <li key={index}>
                            <Skeleton height={30} />
                          </li>
                        ))}
                    </ul>
                  ) : (
                    <>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: showFullDescription
                            ? getEventDetailQuery?.data?.result?.description.replace(
                                /\n\n/g,
                                "<br><br>"
                              )
                            : getEventDetailQuery?.data?.result?.description
                                .replace(/\n\n/g, "<br><br>")
                                .slice(0, 600),
                        }}
                      />
                      {getEventDetailQuery?.data?.result?.description.replace(
                        /\n\n/g,
                        "<br><br>"
                      ).length > 450 && (
                        <button
                          className="btn border-2 mt-4 readMoreButton py-2 px-3"
                          onClick={toggleDescription}
                        >
                          {showFullDescription ? "Read Less" : "Read More"}
                        </button>
                      )}
                    </>
                  )}
                </div>
              </Col>
              <Col lg={6} className="col-12 p-4">
                <div className="plus-jakarta-sans-font text-start">
                  {getEventDetailQuery?.data?.result?.eventRules && (
                    <h2 className="mb-3">Event Rules</h2>
                  )}

                  {getEventDetailQuery.isLoading &&
                    Array(5)
                      .fill()
                      .map((item, index) => (
                        <li key={index}>
                          <Skeleton height={30} />
                        </li>
                      ))}
                  <ul>
                    {rulesToShow?.map((rule) => (
                      <li key={rule.id}>{rule.rule}</li>
                    ))}
                  </ul>
                  {getEventDetailQuery?.data?.result?.eventRules.length > 3 && (
                    <button
                      className="btn border-2 mt-4 readMoreButton py-2 px-3"
                      onClick={toggleEventRules}
                    >
                      {showAll ? "Read Less" : "Read More"}
                    </button>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section-background">
          <Container>
            <Row>
              <Col className="col-12">
                <div className="d-flex justify-content-center flex-column flex-wrap pt-5">
                  <h1 className="bebas-neue-font text-center">
                    DOWNLOAD THE FITEVENT APP <br />
                    AND JOIN NOW!{" "}
                  </h1>
                  <h4 className="plus-jakarta-sans-font text-secondary text-center">
                    Let’s Get Moving!
                  </h4>
                </div>
              </Col>
              <Col className="col-12">
                <div className="d-flex flex-row flex-wrap gap-3 justify-content-center align-items-center pt-4 pb-5">
                  <Link
                    to="https://play.google.com/store/apps?hl=en&gl=US"
                    target="_blank"
                  >
                    <img
                      src="\media\assets\events\google-play.png"
                      alt=""
                      className="img-fluid"
                    />
                  </Link>
                  <Link
                    to="https://www.apple.com/in/app-store/"
                    target="_blank"
                  >
                    <img
                      src="\media\assets\events\app-store.png"
                      alt=""
                      className="img-fluid"
                    />
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Container>
            <Row className="row">
              <Col className="col-12">
                <h1 className="bebas-neue-font py-5 default-text-color text-center mb-0">
                  OTHER EVENTS
                </h1>
              </Col>
            </Row>
          </Container>
          <Marquee getUpcomingEventQuery={getUpcomingEventQuery} />
        </section>
      </main>
    </>
  );
};

export default EventDetails;
